import React from "react";
import { IoNotificationsOutline } from "react-icons/io5";
import { useNotifications } from "../../../context/NotificationContext";
import "./NotificationBell.css";

/** Bell trigger only — panel is rendered once via NotificationPanel. */
const NotificationBell = ({
  className = "",
  variant = "light",
}) => {
  const { unreadCount, panelOpen, togglePanel } = useNotifications();

  const handleBellClick = (event) => {
    event.stopPropagation();
    togglePanel();
  };

  const badgeLabel =
    unreadCount > 99 ? "99+" : unreadCount > 0 ? String(unreadCount) : null;

  const isDark = variant === "dark";

  return (
    <div className={`notification-bell-root ${className}`.trim()}>
      <button
        type="button"
        onClick={handleBellClick}
        className={`notification-bell-btn ${
          isDark ? "notification-bell-btn--dark" : ""
        }`}
        aria-label={`Notifications${unreadCount ? `, ${unreadCount} unread` : ""}`}
        aria-expanded={panelOpen}
        aria-haspopup="true"
      >
        <IoNotificationsOutline className="text-2xl" />
        {badgeLabel && (
          <span className="notification-bell-badge" aria-hidden="true">
            {badgeLabel}
          </span>
        )}
      </button>
    </div>
  );
};

export default NotificationBell;
